import { createContext, useContext, useEffect, useState } from "react";

const KEY = "dep_ejercicio_v1";
const EjercicioContext = createContext(null);

const EMPTY = { cambio: "", importancia: "", primer_paso: "", leadId: null };

export function EjercicioProvider({ children }) {
  const [data, setData] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? { ...EMPTY, ...JSON.parse(raw) } : EMPTY;
    } catch (e) {
      console.warn("EjercicioContext:", e);
      return EMPTY;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) {
      console.warn("EjercicioContext:", e);
    }
  }, [data]);

  const update = (patch) => setData((prev) => ({ ...prev, ...patch }));
  const reset = () => setData(EMPTY);

  return (
    <EjercicioContext.Provider value={{ data, update, reset }}>
      {children}
    </EjercicioContext.Provider>
  );
}

export function useEjercicio() {
  const ctx = useContext(EjercicioContext);
  if (!ctx) throw new Error("useEjercicio fuera del provider");
  return ctx;
}
